/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ChatManagementListMessageResponse } from './ChatManagementListMessageResponse';

export type ChatManagementListMessageResponseApiRespoonse = {
    data?: ChatManagementListMessageResponse;
    status?: ChatManagementListMessageResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ChatManagementListMessageResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

